import React from 'react';
import S from 'StyledChangePasswordForm.js';
import {Field, reduxForm, SubmissionError} from 'redux-form';
import {translation} from 'helpers/utilsHelper.js';
import ModalOpacity from 'ModalOpacity.js';
import useToggle from 'UseToggle.js'
import _get from 'lodash/get';

// Validation
import validation from 'sb-validate-js/validate.js';
import validators from 'validators.enum.js';

const validate = values => {
    const errors = validation(values, validators.CHANGE_PASSWORD);
    return errors;
};

const renderField = ({
    input,
    label,
    type,
                         disabled,
    meta: {touched, error, warning}
}) => {
    return (
        <S.Row>
            <S.InputWrapper>
                <S.Label>{label}</S.Label>
                <S.Input {...input} type={type} required="required" disabled={disabled}/>
                {touched && ((error && <S.Error>{error[0]}</S.Error>) || (warning && <S.Error>{warning}</S.Error>))}
            </S.InputWrapper>
        </S.Row>
    )
};

const ChangePasswordForm = ({changePasswordOnSubmit, handleSubmit, userId, pristine, submitting, error, submitSucceeded}) => {

    const onFormSubmit = async(values) => {

        try {
            const params = {
                oldValue: _get(values, 'oldPassword'),
                newValue: _get(values, 'newPassword'),
                customerId: userId
            };

            await changePasswordOnSubmit(params);
            
        } catch (err) {
            throw new SubmissionError({_error: err});
        }
    };

    return (
        <S.ChangePasswordForm method="post">

            {error && <S.SubmissionError>{error}</S.SubmissionError>}
            {submitSucceeded && <S.SubmissionSuccess>{translation('account_changePasswordForm_success')}</S.SubmissionSuccess>}


            <Field
                name="oldPassword"
                type="password"
                component={renderField}
                label={translation('account_changePasswordForm_oldPassword')}
                disabled={submitSucceeded}
            />
            <Field
                name="newPassword"
                type="password"
                component={renderField}
                label={translation('account_changePasswordForm_newPassword')}
                disabled={submitSucceeded}
            />
            <Field
                name="confirmPassword"
                type="password"
                component={renderField}
                label={translation('account_changePasswordForm_confirmNewPassword')}
                disabled={submitSucceeded}
            />

            <S.SubmitBtn onClick={handleSubmit(onFormSubmit)} disabled={submitting||submitSucceeded}>{translation('account_changePasswordForm_changePassword')}</S.SubmitBtn>

        </S.ChangePasswordForm>
    );
}

export default reduxForm({
    form: 'changePasswordForm',
    validate
})(ChangePasswordForm)
